import { gql } from '@apollo/client';

export default gql`
  mutation popToast {
    popToast @client
  }
`;
